import axios from 'axios';
var OEMBED_URL = 'https://www.wix.com/rich-content/oembed?url=';
var getAbsoluteUrl = function (url) {
    return url.substring(0, 5).includes('http') ? url : "http://".concat(url);
};
var buildUrl = function (url) {
    return OEMBED_URL + encodeURIComponent(getAbsoluteUrl(url));
};
export var fetchUrlPreviewData = function (url) {
    // Errors are ignored and the preview is skipped in that case.
    // Also for `wix` provider items, skip the `html` embed data and pass along
    // basic attributes for rendering a generic preview.
    return axios
        .get(buildUrl(url))
        .then(function (res) {
        var data = res.data || {};
        // Ignore our urls until we have time to generate full previews
        if ((data === null || data === void 0 ? void 0 : data.provider_url) === 'https://www.deviantart.com') {
            return {};
        }
        return (data === null || data === void 0 ? void 0 : data.provider_name) === 'wix'
            ? {
                title: data.title,
                description: data.description,
                thumbnail_url: data.thumbnail_url,
            }
            : data;
    })
        .catch(function () { return ({}); });
};
//# sourceMappingURL=util.js.map